import { FieldModel } from '@cibo/core'
import { WaterPumpIrrigationCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface WaterPumpIrrigationCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
  // traitId: string
}

export const WaterPumpIrrigationCell = ({
  value,
  task,
  selectedField,
  year,
}: WaterPumpIrrigationCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="waterPumpIrrigation"
    >
      <WaterPumpIrrigationCellDisplay value={value} />
    </TraitCellContainer>
  )
}
